import { useFormikContext } from 'formik';
import GenerateFormHTMLNoValid from '../../../../../component/generate-form/GenerateFormHTMLNoValid';
import { parseJSON } from '../../../../../utils/FormatUtils';

const PhieuKhamChuyenKhoa = () => {
	const { values, touched, errors, setFieldValue } = useFormikContext<any>();

	return (
		<div className="inner-form-generate">
			<GenerateFormHTMLNoValid
				listFieldAuto={parseJSON(values?.jsonTemplate)}
				values={values}
				errors={errors}
				touched={touched}
				setFieldValue={setFieldValue}
				modelID="form"
			/>
		</div>
	);
};

export default PhieuKhamChuyenKhoa;
